<template>
  <div class="employment-action-column">
    <WdsMenu z-index="1000" placement="bottom-end">
      <template #trigger>
        <WdsButtonGhost :label="$t('More options')" data-test="employment-actions-menu">
          <WdsIcon name="overflow-menu-horizontal" />
        </WdsButtonGhost>
      </template>

      <WdsMenuOption data-test="see-worker-details-option" @click="seeWorkerDetails">
        <WdsStack direction-row align-center gap-sm>
          <WdsIcon name="person" :size="16" />
          {{ $t('See worker details') }}
        </WdsStack>
      </WdsMenuOption>
    </WdsMenu>
  </div>
</template>

<script lang="ts" setup>
import { WdsButtonGhost, WdsIcon, WdsMenu, WdsMenuOption, WdsStack } from '@worksome/wds-components'
import { computed } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { FragmentType, graphql, useFragment } from '@/gql'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'

const { openPartnerWorkerDetailPanel } = useTablePanels()

const EmploymentActionColumnOnboarded = graphql(`
  fragment EmploymentActionColumnOnboarded on Employment {
    id
    worker {
      id
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof EmploymentActionColumnOnboarded>
}>()

const column = computed(() => useFragment(EmploymentActionColumnOnboarded, props.row))

const seeWorkerDetails = () => {
  openPartnerWorkerDetailPanel({
    workerId: column.value.worker.id,
    employmentId: column.value.id,
  })
}
</script>

<style scoped lang="scss">
.employment-action-column {
  :deep(.wds-menu) {
    width: max-content;
  }
}
</style>
